import React, { useEffect } from 'react';
import { FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { InputFormField } from '../../../../components/formFields/InputFormField';
import { AreaFormField } from '../../../../components/formFields/AreaFormField';
import { getFieldErrors } from '../../../../utils/apiError';

const ValidationSchema = Yup.object().shape({
  title: Yup.string().required('Povinné pole'),
  address: Yup.string().required('Povinné pole'),
  invoicing_email: Yup.string().email('Zadejte validní e-mail!').required('Povinné pole'),
  ico: Yup.string()
    .matches(/^\d{8}$/, 'IČO musí mít přesně 8 číslic')
    .required('Povinné pole'),
});

interface EditCompanyFormProps {
  formProps?: Record<string, any>;
  onSubmit: (values: any) => void;
  error?: any;
  isIco?: boolean;
  ares?: any;
  reset?: boolean;
  resetConfirm?: () => void;
}

const EditCompanyForm = ({
  formProps,
  onSubmit,
  error,
  isIco = false,
  ares = null,
}: EditCompanyFormProps) => {
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: ValidationSchema,
    initialValues: {
      ico: formProps?.ico ?? '',
      dic: formProps?.dic ?? '',
      title: formProps?.title ?? '',
      address: formProps?.address ?? '',
      description: formProps?.description ?? '',
      invoicing_email: formProps?.invoicing_email ?? '',
    },
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  useEffect(() => {
    formik.setErrors(getFieldErrors(error));
  }, [error]);

  useEffect(() => {
    if (ares) {
      formik.setValues(ares);
    }
  }, [ares]);

  const values = formik.values;

  return (
    <FormikProvider value={formik}>
      <div>
        <form
          id="company-form"
          className="space-y-1"
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit();
          }}
        >
          <InputFormField
            disabled={!!formProps?.ico}
            name="ico"
            value={values.ico}
            label="IČO"
            placeholder="IČO"
            data-testid="company-form-ico-input"
            {...formik}
          />

          {!isIco && (
            <>
              <InputFormField
                name="invoicing_email"
                value={values.invoicing_email}
                label="Faktury zasílat"
                placeholder="email"
                data-testid="company-form-invoicing-email-input"
                {...formik}
              />
              <InputFormField
                name="dic"
                value={values.dic}
                label="DIČ"
                placeholder="DIČ"
                data-testid="company-form-dic-input"
                {...formik}
              />
              <InputFormField
                name="title"
                value={values.title}
                label="Název"
                placeholder="Název"
                data-testid="company-form-title-input"
                {...formik}
              />
              <InputFormField
                name="address"
                value={values.address}
                label="Sídlo"
                placeholder="Sídlo"
                data-testid="company-form-address-input"
                {...formik}
              />
              <AreaFormField
                name="description"
                value={values.description}
                label="Zaměření"
                placeholder="Zaměření"
                data-testid="company-form-description-input"
                {...formik}
              />
            </>
          )}
        </form>
      </div>
    </FormikProvider>
  );
};

export default EditCompanyForm;
